import React from 'react';
import { SectionHeader } from './SectionHeader';
const audience = [{
  icon: '🎓',
  title: 'Tenés un parcial encima',
  desc: 'Y necesitás un plan concreto para los próximos días, sin vueltas.'
}, {
  icon: '😓',
  title: 'Llegás siempre al límite',
  desc: 'Cuatrimestre tras cuatrimestre, el mismo ciclo de crisis. Ya estás cansado.'
}, {
  icon: '🧠',
  title: 'Sabés pero no podés demostrarlo',
  desc: 'Te bloqueás en el examen aunque hayas estudiado. El problema no es el contenido.'
}, {
  icon: '📉',
  title: 'Reprobaste y necesitás levantarte',
  desc: 'Necesitás más que motivación: necesitás un plan real para el recuperatorio.'
}];
export function TargetAudience() {
  return <section className="py-20 px-6 lg:px-8 bg-cream" data-id="element-197">
      <div className="max-w-[1100px] mx-auto" data-id="element-198">
        <SectionHeader data-id="element-199" />
        <div className="text-center mb-12" data-id="element-200">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-201">
            ¿PARA QUIÉN ES APROBÁ EN SERIO?
          </h2>
          <p className="text-xl text-dark/70 font-medium" data-id="element-202">
            Diseñado para vos si...
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-6 items-stretch mb-12" data-id="element-203">
          {audience.map((item, idx) => <div key={idx} className="bg-white p-3 md:p-6 rounded-[10px] md:rounded-2xl border border-[#EEEEEE] shadow-sm flex flex-col" data-id="element-204">
              <div className="flex items-center gap-2 md:flex-col md:items-start mb-1.5 md:mb-4" data-id="element-205">
                <span className="text-2xl md:text-4xl bg-palegreen/30 rounded-lg md:rounded-xl w-9 h-9 md:w-auto md:h-auto flex items-center justify-center md:p-4 shrink-0 leading-none" data-id="element-206">
                  {item.icon}
                </span>
                <h3 className="font-bold text-[13px] md:text-lg leading-tight" data-id="element-207">
                  {item.title}
                </h3>
              </div>
              <p className="text-[11px] md:text-sm text-dark/60 leading-[1.4] md:leading-relaxed" data-id="element-208">
                {item.desc}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-209">
          <p className="text-sm font-semibold text-dark/60 bg-white inline-block px-6 py-2 rounded-full border border-border" data-id="element-210">
            ¿No estás seguro si es para vos? Tenés 7 días de garantía →
          </p>
        </div>
      </div>
    </section>;
}